/**
 * @author: liaojianming
 * @date 2019-02-18
 * @description: Enum.js 公用枚举类
*/

export default {
    toArray: function(enumObj) {
        var array = [];
		for (var key in enumObj.num) {
			array.push({
				label: enumObj.getValue(enumObj.num[key]),
				value: enumObj.num[key]
			});
		}
		return array;
	},
	common: {
		// 是否更新状态
		isUpdateStatus: {
			num: {
				notUpdate: 0,
				isUpdate: 1
			},
			getValue: function(num){
				var text;
				switch(Number(num)) {
					case this.num.notUpdate:
						text = '否';
						break;
					case this.num.isUpdate:
						text = '是';
						break;
					default:
						text = '未知状态码';
						break;
				}
				return text;
			}
		},
		requestMethods: {
			num: {
				put: 'put',
				delete: 'delete',
				post: 'post',
				get: 'get'
			},
			getValue: function(num) {
				switch(num) {
					case this.num.put:
						return 'PUT';
					case this.num.delete:
						return 'DELETE';
					case this.num.post:
						return 'POST';
					case this.num.get:
						return 'GET';
					default:
						return '';
				}
			}
		}
	},
	//系统权限
	systemPermission: {
		// 系统权限 - 菜单模块
		menuManage: {
			// 菜单类型
			menuType: {
				num: {
					list: 0,
					menu: 1,
					button: 2
				},
				getValue: function(num) {
					switch(num) {
						case this.num.list:
							return '目录';
						case this.num.menu:
							return '菜单';
						case this.num.button:
							return '按钮';
						default:
							return '';
					}
				}
			},
			// 是否为系统
			systemFlag: {
				num: {
					notSystem: 0,
					isSystem: 1
				},
				getValue: function(num) {
					switch(num) {
						case this.num.notSystem:
							return '否';
						case this.num.isSystem:
							return '是';
						default:
							return '';
					}
				}
			},
			// 是否可见
			visibleFlag: {
				num: {
					notVisible: 0,
					isVisible: 1
				},
				getValue: function(num) {
					switch(num) {
						case this.num.notVisible:
							return '否';
						case this.num.isVisible:
							return '是';
						default:
							return '';
					}
				}
			}
		},
		// 组织架构
		organizationManage: {
			deptType: {
				num: {
					groupCompany: 0,
					company: 1,
					department: 2
				},
				getValue: function(num) {
					switch(num) {
						case this.num.groupCompany:
							return '集团';
						case this.num.company:
							return '公司';
						case this.num.department:
							return '部门';
						default:
							return '';
					}
				}
			}
		},
		// 角色模块
		roleManage: {
			roleAvailable: {
				num: {
					disabled: 0,
					enable: 1
				},
				getValue: function(num) {
					switch(num) {
						case this.num.enable:
							return '启用';
						case this.num.disabled:
							return '禁用';
						default:
							return '';
					}
				}
			}
		}
	},
	// 审批列表
	approvalMagage: {
		// 审批列表 - 页面内顶部菜单
		headerMenu: {
			num: {
				myApproval: '1',
				myStart: "2",
				copyToMe: '3',
				dataExport: '4',
				allWorkOrder: '5',
			},
			getValue: function(num) {
				var text;
				switch(num) {
					case this.num.myApproval:
						text = '我审批的';
						break;
					case this.num.myStart:
						text = '我发起的';
						break;
					case this.num.copyToMe:
						text = '抄送我的';
						break;
					case this.num.dataExport:
						text = '数据导出';
						break;
					case this.num.allWorkOrder:
						text = '全部工单';
						break;
					default:
						text = '未知菜单';
				}
				return text;
			}
		}
	},
	//菜单属性类型
	menuAttrType:{
		num:{
			row:1,
			col:2
		},
		getValue:function(num){
			switch(num){
				case this.num.row:
					return '行属性';
					break;
				case this.num.col:
					return '列属性';
					break;
			}
		}
	},
	//审批管理
	approvalManage: {
		common: {},
		//审批流程
		approvalProcess: {
			
		}
	},
	day_year: [
		[0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
		[0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    ],
}
